import { render, staticRenderFns } from "./ChargerDetails.vue?vue&type=template&id=6a2c5af4&"
import script from "./ChargerDetails.vue?vue&type=script&lang=js&"
export * from "./ChargerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports